module.exports = __webpack_public_path__ + "img/product_info.80adde9b.jpg";